"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidGridView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const components_1 = require("./FluidGridView/components");
const FluidGridElement_1 = require("./FluidGridView/FluidGridElement");
function FluidGridView({ data, loading, displayCap = 6, select, onLoadMore, className, element, }) {
    const [toDisplay, setToDisplay] = (0, react_1.useState)(displayCap);
    const elements = (0, react_1.useMemo)(() => data
        .slice(0, toDisplay)
        .map((record, i) => ((0, jsx_runtime_1.jsx)(FluidGridElement_1.FluidGridElement, { index: i, select: select, data: record, element: element }, record.id))), [data, element, select, toDisplay]);
    const expandable = data.length > toDisplay;
    const displayAll = data.length === toDisplay;
    const toggle = () => {
        if (!displayAll) {
            void (onLoadMore === null || onLoadMore === void 0 ? void 0 : onLoadMore());
        }
        setToDisplay((prev) => Math.min(prev + displayCap, data.length));
    };
    return ((0, jsx_runtime_1.jsxs)(ui_1.Section, Object.assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(components_1.GridWrap, Object.assign({ templateColumns: "repeat(2, 1fr)", gap: "medium" }, { children: elements })), expandable && !loading ? ((0, jsx_runtime_1.jsx)(components_1.CenterButton, Object.assign({ kind: "transparent", onClick: toggle }, { children: (0, jsx_runtime_1.jsxs)(components_1.CenterStack, Object.assign({ spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: displayAll ? 'Collapse' : 'Expand' })), displayAll ? ((0, jsx_runtime_1.jsx)(svg_1.SvgArrowUp, { height: "1.2rem", width: "1.2rem", strokeWidth: "1px" })) : ((0, jsx_runtime_1.jsx)(svg_1.SvgArrowDown, { height: "1.2rem", width: "1.2rem", strokeWidth: "1px" }))] })) }))) : loading ? ((0, jsx_runtime_1.jsx)(ui_1.Loading, {})) : null] })));
}
exports.FluidGridView = FluidGridView;
